import { Component, Input, OnInit } from '@angular/core';
import { CourseIntro } from '../../models/course-intro.model';

@Component({
  selector: 'app-course-intro',
  templateUrl: './course-intro.component.html',
  styleUrls: ['./course-intro.component.scss'],
})
export class CourseIntroComponent implements OnInit {
  @Input() courseIntro = {} as CourseIntro;

  // basic property is for rendering h2 or h3 tag for title depending on the importance of the current component in the page it is being used
  @Input() basic = false; 

  constructor() {}

  ngOnInit(): void {}

  goTop() {
    window.scrollTo(0,0);
  }
}